import blank from './blank';
// import threeColumn from './three-column';
import fullWidth from './full-width';
// import centered from './centered';
// import centeredNoChrome from './centered-no-chrome';
// import leftSidebar from './left-sidebar';
// import leftSidebarNoChrome from './left-sidebar-no-chrome';
// import rightSidebar from './right-sidebar';
// import rightSidebarNoChrome from './right-sidebar-no-chrome';
// import threeColumnNoChrome from './three-column-no-chrome';
import { htmlPageChromeCss } from './chrome-styles';

export const htmlPageLayouts = [
  blank, fullWidth
];
export const htmlPageZipTrait = {
  type: 'html-page-zip-upload', name: 'htmlPageZipUpload', label: 'Reupload HTML ZIP',
};
export const htmlPageMetadataTraits = [
  { type: 'html-page-upload-info', name: 'htmlPageUrl', label: 'Page URL', uploadField: 'url' },
  { type: 'html-page-upload-info', name: 'htmlPageUploadVersion', label: 'Version', uploadField: 'version' },
  { type: 'html-page-upload-info', name: 'htmlPageUploadedZip', label: 'Uploaded ZIP', uploadField: 'uploadedZipName' },
  { type: 'html-page-upload-info', name: 'htmlPageLastModified', label: 'Last modified', uploadField: 'updatedAt' },
  { type: 'html-page-upload-info', name: 'htmlPageZipSize', label: 'ZIP size', uploadField: 'uploadedZipSize' },
  { type: 'html-page-upload-info', name: 'htmlPageUploadState', label: 'Upload status', uploadField: 'uploadState' },
  { type: 'html-page-upload-info', name: 'htmlPagePendingVersion', label: 'Attempt version', uploadField: 'pendingVersion' },
  { type: 'html-page-upload-info', name: 'htmlPageUploadError', label: 'Last upload error', uploadField: 'uploadError' },
];
const handlerTraits = () => [...htmlPageMetadataTraits, htmlPageZipTrait].map((trait) => ({ ...trait }));
export const htmlPageHandlerDefinition = {
  name: 'HTML Page Handler', traits: handlerTraits(), attributes: { title: 'Static page content', ENDPOINTS: [] },
};

const pageRow = (className, components, options = {}) => ({
  type: 'default',
  tagName: 'section',
  classes: [className],
  attributes: { class: className, htmlPageLayout: true, 'data-html-page-row': className },
  components,
  droppable: true,
  removable: false,
  copyable: false,
  ...options,
});

const normalizeChromeNode = (node) => ({
  ...node,
  type: node.type || node.name,
  attributes: { ...(node.attributes || {}), htmlPageLayout: true },
});

export function buildHtmlPageLayout(layoutId, chrome = []) {
  const layout = htmlPageLayouts.find((item) => item.id === layoutId);
  if (!layout) throw new Error('Invalid page layout.');
  const handler = { name: 'HTML Page Handler', type: 'HTML Page Handler',
    traits: handlerTraits(),
    removable: false, copyable: false, draggable: false, droppable: false,
    attributes: { title: 'Static page content', ENDPOINTS: [] } };
  const headers = layout.includeChrome === false ? [] : chrome.filter((node) => /Header|Main Menu/.test(node.name));
  const footers = layout.includeChrome === false ? [] : chrome.filter((node) => /Footer/.test(node.name));
  const content = layout.build(handler);
  const rows = [];

  if (headers.length) rows.push(pageRow('html-page-header-row', headers.map(normalizeChromeNode), {
    name: 'Header', tagName: 'header',
  }));
  rows.push(pageRow('html-page-content-row', content, {
    name: 'Content', tagName: 'main', droppable: true,
  }));
  if (footers.length) rows.push(pageRow('html-page-footer-row', footers.map(normalizeChromeNode), {
    name: 'Footer', tagName: 'footer',
  }));

  return { json: JSON.stringify(rows), css: JSON.stringify(`${layout.css || ''}${htmlPageChromeCss}`) };
}
